import PropTypes from 'prop-types'
import Header from './Header'

/**
 * DatasetsLayout Component
 *
 * Simple layout for the Datasets page
 * Includes header with navigation but no location selector or modals
 * since datasets page doesn't need location context
 */
function DatasetsLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-6">{children}</main>
    </div>
  )
}

DatasetsLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default DatasetsLayout
